import type { AxiosError } from 'axios';

import { axiosInstance } from '@configs/axios/axiosInstance';

import type { SelectedOrganization } from '../types/organization.types';

/**
 * Get currently selected organization
 * Endpoint: GET /users/selected-organization
 * Returns: SelectedOrganization | null
 *
 * Backend returns 204 No Content when no selection (first-time Manage user)
 * Frontend handles 204 by returning null
 */
export async function fetchSelectedOrganization(): Promise<SelectedOrganization | null> {
  try {
    const { data } = await axiosInstance.get<SelectedOrganization>(
      '/users/selected-organization'
    );
    return data;
  } catch (error) {
    if ((error as AxiosError).response?.status === 204) {
      return null;
    }
    throw error;
  }
}
